import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex pointer-events-none items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',

        // 🌈 New light color variants
        blue: 'border-transparent bg-blue-50 text-blue-800 hover:bg-blue-100',
        green: 'border-transparent bg-green-50 text-green-800 hover:bg-green-100',
        purple: 'border-transparent bg-purple-100 text-purple-800 hover:bg-purple-100',
        orange: 'border-transparent bg-orange-50 text-orange-800 hover:bg-orange-100',
        gray: 'border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
